export default {
  SolutionFaceIn: [{
    title: '算法领先',
    iconLogo: require('../img/advantage/facein_face_pic3.1.png'),
    content: '算法在多个国际公开竞赛中刷新纪录，人脸比对在2017年的 LFW 测评准确度高达99.80%，识别准确率业界领先。'
  }, {
    title: '服务灵活',
    iconLogo: require('../img/advantage/facein_face_pic3.4.png'),
    content: '支持混合、公有部署模式，可根据行业特性和业务要求使用不同的部署模式，产品功能也可根据需求灵活组合。'
  }, {
    pos: true,
    title: '接入全面',
    iconLogo: require('../img/advantage/facein_face_pic3.3.png'),
    content: '提供微信H5、小程序、sdk 等多种 SaaS 化服务，以及 API接口，满足客户在不同场景实名认证需求。'
  }, {
    title: '安全可靠',
    iconLogo: require('../img/advantage/icon_aq.png'),
    content: '活体检测可抵挡照片、视频、静态3D模型的攻击，并结合腾讯多年安全积累和大数据安全技术能力，提供可靠的安全保障。'
  }],
  SolutionForgery: [{
    title: '证件范围广',
    iconLogo: require('../img/advantage/icon_all.png'),
    content: '目前已支持香港身份证和马来身份证证件鉴伪，后续扩展支持其它类型证件。'
  }, {
    title: '使用便捷',
    iconLogo: require('../img/advantage/icon_id_antifake_pic3.2.svg'),
    content: '用户只需按照提示完成简单的手机翻转动作即可完成检测。'
  }, {
    pos: true,
    title: '高精度',
    iconLogo: require('../img/advantage/cwpj_pic2.4.png'),
    content: '在保证真证通过率不低于90%前提下，伪证拦截率可达99%。'
  }, {
    title: '高安全性',
    iconLogo: require('../img/advantage/icon_aq.png'),
    content: '有效覆盖身份证的证件鉴伪点识别，保证鉴伪的准确性和安全性。'
  }],
  SolutionAuditing: [{
    title: '一体化接入',
    content: '优图内容审核通过一体化接口同时接入多项审核服务，业务方可以根据自身需求灵活组合，使用便捷。',
    iconLogo: require('../img/advantage/safe_pic3.1.png')
  }, {
    title: '多标签体系',
    content: '优图内容审核解决方案涵盖色情、暴恐、涉政、广告、违法违规5大标签体系，包含细分标签种类70+，全方位覆盖政策法规和行业需求，满足客户多业务多场景需求。',
    iconLogo: require('../img/advantage/safe_pic3.2.svg')
  }, {
    title: '自助化训练平台',
    content: '优图基于自研迁移学习算法打造在线训练平台，数据挖掘、数据管理、模型训练、模型评测、模型发布全流程平台自动化，帮助客户解决大量定制化需求，实现需求快速响应。',
    iconLogo: require('../img/advantage/safe_pic3.3.svg')
  }],
  SolutionBroadcast: [{
    title: '使用方便',
    content: '优图美颜特效能力以离线SDK形式提供，在保证丰富功能的前提下调用简单，并支持个性化配置。',
    iconLogo: require('../img/advantage/you_video_pic3.1.png')
  }, {
    title: '效果自然',
    content: '优图通过在图像融合、图像增强、精细形变控制等技术上反复打磨，打造出最具有真实感的美颜特效效果。',
    iconLogo: require('../img/advantage/you_video_pic3.2.png')
  }, {
    title: '快速迭代能力',
    content: '优图持续探索打磨各项图像及人脸处理技术，快速将新的技术和能力合入视频直播解决方案，满足用户在不同场景下的使用。',
    iconLogo: require('../img/advantage/fast_iterative_capability.png')
  }, {
    title: '主播核身安全性高',
    content: '优图主播核身服务在错误接受率0.01%的情况下，通过率达到98%，同时独创基于唇语验证的活体检测技术，安全系数极高。',
    iconLogo: require('../img/advantage/you_video_pic3.4.png')
  }],
  SolutionInvoice: [{
    title: '票据类型全',
    content: '支持增值税发票、增值税发票（卷票）、火车票、汽车票、轮船票、飞机行程单、出租车票、过路费发票、定额发票、机动车购置发票、二手车购买发票、通用机打发票等。',
    iconLogo: require('../img/advantage/cwpj_pic2.1.png')
  }, {
    title: '字段支持全',
    content: '支持日期、金额、发票代码、发票号码、纳税人识别号等各类结构化字段，票据信息识别齐全。',
    iconLogo: require('../img/advantage/cwpj_pic2.2.png')
  }, {
    title: '覆盖场景全',
    content: '支持单张票据、多张票据混贴识别；支持照片、扫描件识别；不受拍摄角度、背景、亮度、折痕、内容错位等不利因素干扰。',
    iconLogo: require('../img/advantage/cwpj_pic2.3.png')
  }, {
    title: '准确率高',
    content: '字符准确率在99%以上；核心字段准确率在98%以上。',
    iconLogo: require('../img/advantage/cwpj_pic2.4.png')
  }],
  SolutionEducation: [{
    title: '多教育场景支持',
    content: '覆盖了数学、语文、英文等核心学科的教育需求。',
    iconLogo: require('../img/advantage/icon_1djy.png')
  }, {
    title: '能力使用灵活',
    content: '结合方案中的多种基础能力，可以灵活打造工具，满足特定业务场景需求。',
    iconLogo: require('../img/advantage/icon_2lh.jpg')
  }],
  SolutionVideoUnderstand: [{
    title: '标签丰富',
    content: '拥有5000+帧标签，18万+短视频标签，其中帧视频标签涵盖人物、风景、物品、动物、植物、事件、场景、卡证文档8大类，短视频标签涵盖综艺、美食、自拍、情感、搞笑等31大类，标签体系覆盖范围广，可满足客户多方位标签需求。',
    iconLogo: require('../img/advantage/splj_pic3.1.png')
  }, {
    title: '落地场景丰富',
    content: '目前已广泛应用微信看一看、PCG视频理解中台等众多腾讯产品，帮助产品提升用户浏览时长和进行精准推荐。',
    iconLogo: require('../img/advantage/splj_pic3.2.png')
  }],
  SolutionFaceInFW: [{
    title: '安全性强',
    content: '基于数字图像处理和人工智能技术，对视频或图像中人脸进行全方面分析，实现对伪造人脸（人脸生成、融合、修改、区域编辑）的精准识别，保护用户权益。',
    iconLogo: require('../img/advantage/icon_safe.png')
  }, {
    title: '全面鉴别',
    content: '人脸编辑检测技术从全局分布到局部细节进行多尺度分析，同时结合图像的底层纹理特征和高层的语义特征进行多层次分析，最后得出相应的分析结果。',
    iconLogo: require('../img/advantage/icon_all.png')
  }, {
    title: '准确率高',
    content: '通过对图像、视频的全面分析，可以快速、准确地进行真伪鉴别，覆盖多种人脸编辑算法，准确率达99%。',
    iconLogo: require('../img/advantage/high_accuracy_recognition.png')
  }, {
    title: '适用性强',
    content: '适用于复杂图像及视频识别，支持多种格式检测和多人同屏精准识别。',
    iconLogo: require('../img/advantage/icon_adaptation.png')
  }],
  SolutionInsurance: [{
    title: '覆盖版式广',
    content: '核保环节中，支持爱康国宾、美年健康、慈铭体检、第一健康等机构体检报告的识别；理赔环节中，支持病案首页、费用清单、结算单、医疗发票等单据的识别。',
    iconLogo: require('../img/advantage/znbx_pic2.1.png')
  }, {
    title: '支持字段全',
    content: '支持核保单据200多个字段、理赔单据400多个字段。',
    iconLogo: require('../img/advantage/znbx_pic2.2.png')
  }, {
    title: '准确率高',
    content: '字符识别准确率高达98%以上，字段识别准确率在85%以上。',
    iconLogo: require('../img/advantage/znbx_pic2.3.png')
  }, {
    title: '可定制化',
    content: '针对特定场景，提供定制化的智能识别服务，进而提升识别精度，满足客户的业务场景需求。',
    iconLogo: require('../img/advantage/znbx_pic2.4.png')
  }],
  SolutionSDKProduction: [{
    title: '功能丰富',
    content: '基于优图先进的人脸定位及图像处理技术，提供包含人像分割、基础美颜、人脸试妆、人脸贴纸、图像滤镜等功能。',
    iconLogo: require('../img/advantage/sdk_pic2.1.jpg')
  }, {
    title: '定制组合',
    content: '各种功能可以根据需求单独或自由组合使用。',
    iconLogo: require('../img/advantage/icon_adaptation.png')
  }, {
    title: '效果精准',
    content: '人脸定位精准度高，面部细节效果自然精准。',
    iconLogo: require('../img/advantage/high_accuracy_recognition.png')
  }, {
    title: '处理高效。',
    content: '采用优图开源的TNN前向推断框架，达到毫秒级响应处理速度。',
    iconLogo: require('../img/advantage/sdk_pic2.4.jpg')
  }, {
    title: '自由灵活',
    content: '多种参数、特效强度支持自定义调节，轻松打造用户想要的特效效果。',
    iconLogo: require('../img/advantage/sdk_pic2.5.jpg')
  }],

  SolutionTim: [{
    title: '高度行业定制，业务理解深刻',
    content: '针对传媒侧专项研发和优化全部能力，算法和功能针对传媒业务高度定制。唯一按照行业业务标准（广电四层编目粒度）并支持多类型（新闻、综艺、综艺晚会等），进行视频拆分并保证逐层信息完整准确的产品',
    iconLogo: require('../img/advantage/dingzhi.svg')
  }, {
    title: '数据、算法能力全面领先',
    content: '媒体AI中台有着多次刷新世界纪录的各维度的算法，和多年业务沉淀的丰富数据和标签。结合深刻的业务理解，形成行业最优秀的解决方案',
    iconLogo: require('../img/advantage/AI.svg')
  }, {
    title: '平台能力优秀',
    content: `模块化设计：基于客户业务场景，通过修改PPL提供多种标签输出方案。
    灵活配置：原子能力阈值可配置，可针对性地对各类业务场景进行调整和优化。
    稳定可靠：应用与平台高内聚低耦合，系统健壮性强，如出故障可快速定位并修复`,
    iconLogo: require('../img/advantage/pingtai.svg')
  }]
};



// WEBPACK FOOTER //
// ./src/components/open/panels/solution/panels/data/AdvantageConstant.js